"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardStyled = void 0;
const design_system_1 = require("@produits-internes-oss/design-system");
const constants_1 = require("../../theme/constants");
exports.CardStyled = styled.button `
&.octo {
  display: flex;
  gap: 1em;
  align-items: stretch;
  justify-content: stretch;
  min-height: 10em;
  padding: 1em;
  border-width: 0.0625em;
  border-style: solid;
  border-color: ${design_system_1.theme.colors.marine[50]};
  border-radius: 1em;
  background-color: ${design_system_1.theme.colors.white};
  color: ${design_system_1.theme.colors.marine[100]};
  box-shadow: 0 0 0 0.125em transparent;
  cursor: pointer;
  transition: ${constants_1.transitions.fast};
  transition-property: border-color, box-shadow;

  @media (min-width: ${constants_1.sizes.tablet}) {
    flex-flow: row nowrap;
  }

  @media (max-width: ${constants_1.sizes.tablet}) {
    flex-flow: column nowrap;
  }

  >.logo {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;

    > img {
      object-fit: contain;
      object-position: left;

      @media (min-width: ${constants_1.sizes.tablet}) {
        width: 10em;
        height: 9em;
      }

      @media (max-width: ${constants_1.sizes.tablet}) {
        width: 7.5em;
        height: 6.5em;
      }
    }
  }

  >.panel {
    display: flex;
    flex: 1;
    flex-flow: column;
    gap: 0.25em;
    align-items: stretch;
    justify-content: stretch;

    @media (min-width: ${constants_1.sizes.tablet}) {
      gap: 0.25em;
    }

    @media (max-width: ${constants_1.sizes.tablet}) {
      gap: 1em;
    }

    > h2 {
      display: flex;
      flex-flow: row wrap;
      align-items: end;
      width: 100%;
      font-weight: 600;
      text-transform: capitalize;

      @media (min-width: ${constants_1.sizes.tablet}) {
        flex: 1;
        justify-content: flex-start;
      }

      @media (max-width: ${constants_1.sizes.tablet}) {
        flex: 0;
        justify-content: center;
      }

      span {
        @media (min-width: ${constants_1.sizes.tablet}) {
          font-size: 2.5em;
        }

        @media (max-width: ${constants_1.sizes.tablet}) {
          font-size: 2em;
        }
      }
    }

    >.content {
      display: flex;
      flex: 1;
      flex-flow: row wrap;
      gap: 0.5em;
      align-content: baseline;
      justify-content: stretch;
      min-height: 3em;

      @media (min-width: ${constants_1.sizes.tablet}) {
        justify-content: stretch;
      }

      @media (max-width: ${constants_1.sizes.tablet}) {
        justify-content: center;
      }
    }
  }

  &:hover {
    &:not(:has(button:hover)) {
      border-color: transparent;
      box-shadow: 0 0 0 0.125em ${design_system_1.theme.colors.marine[100]};
    }
  }

  &.compact {
    flex-flow: column nowrap;

    >.logo {
      > img {
        object-position: center;
      }
    }

    >.panel {
      > h2 {
        flex: 0;
        justify-content: center;
        text-align: center;

        > span {
          font-size: 1em;
        }
      }

      >.content {
        flex-flow: column nowrap;
        align-items: center;
      }
    }
  }
}
`;
//# sourceMappingURL=Card.styled.js.map